import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { useBusiness, useUser } from 'graphql/graph-hooks';
import { DancerMenu } from 'components/common/dancer-action-menu/dancer-action-menu';

import S from './chat-msg-head.module.scss';
import DancerProfileImage from 'components/common/images/dancer-profile-image';
import type { Image as ImageType } from 'types';

type blockedByType = {
  id: string;
  name: string;
};

type ChatMsgHeadProps = {
  id: string;
  name: string;
  email?: string;
  first_image: ImageType;
  suspended: boolean;
  blocked_by: blockedByType | null;
  in_group: boolean;
  avatarOnClick: (id: string) => void;
};

const ChatMsgHead: React.FC<ChatMsgHeadProps> = ({
  id: receiverId,
  name,
  email,
  first_image,
  suspended,
  blocked_by,
  in_group: inGroup,
  avatarOnClick,
}) => {
  const { admin: isAdmin } = useUser();

  const { id: currentBusinessId } = useBusiness();
  const { t } = useTranslation();

  return (
    <div className={S.msgReceiver}>
      <div className={S.imgDivWrapper} onClick={() => avatarOnClick(receiverId)}>
        <DancerProfileImage
          classname={classNames({ [S.suspended]: suspended, [S.inGroup]: inGroup })}
          image={first_image}
          size='thumb'
          alt={name}
        />
      </div>
      <div className={S.msgReceiverDetails}>
        <h4>
          {name}
          <div className={S.discipline}>
            {suspended && <span className={S.suspended}>({t('common.paused').toUpperCase()})</span>}
            {blocked_by && (
              <span className={S.blocked}>
                ({t('dancerPage.blocked_by')} {blocked_by.name})
              </span>
            )}
          </div>
        </h4>
        {isAdmin && <p>{email}</p>}
      </div>

      {!isAdmin && <DancerMenu dancerId={receiverId} businessId={currentBusinessId} />}
    </div>
  );
};

export { ChatMsgHead };
